import _ from "lodash";

// Formateo de usuarios del reporte
export const formatReportUsers = (users) => {
  const email = JSON.parse(localStorage.getItem("Session"))?.email;
  let usersInfo = { raw: [], formatted: [] };
  let meInfo = { raw: [], formatted: [] };
  if (!(Array.isArray(users) && users.length > 0)) return { usersInfo, meInfo };
  const meIdx = users.findIndex((user) => user.email === email);
  let usersWithoutMe = _.cloneDeep(users);
  const meArray = usersWithoutMe.splice(meIdx, 1);
  // Me
  if (meIdx !== -1) {
    meInfo = {
      raw: meArray,
      formatted: meArray.map((user) => {
        // const fullName = `${user.first_name} ${user.last_name}`.trim();
        const fullName = user.name;
        return {
          label: fullName || user.email,
          value: user.email,
        }
      }),
    }
  };
  // Users without me
  usersInfo = {
    raw: usersWithoutMe,
    formatted: usersWithoutMe.map((user) => {
      // const fullName = `${user.first_name} ${user.last_name}`.trim();
      const fullName = user.name;
      return {
        label: fullName || user.email,
        value: user.email,
      }
    }),
  };
  return {
    usersInfo,
    meInfo,
  };
}

// Formateo de campos relativos del reporte
export const formatReportRelativeFields = (report) => {

  const { stepers = [], form: formFromReport = [] } = report;

  const information = {};

  for (const step of stepers) {
    const { form = [] } = step;
    for (const field of form) {
      const pathFormatted = field.path.replace(/::/g, ".");
      const { role } = _.get(formFromReport, `${pathFormatted}`);
      if (role) {
        information[role] = field.value || "";
      }
    }
  }

  return information;
}

// Formateo de recursos de la investigación
export const formatInvestigationResources = (investigation) => {
  //---> Human resources <---//
  let humanResources = { raw: [], formatted: [], approved: [], approvedFormatted: [] };
  let accessResources = { raw: [], formatted: [], approved: [], approvedFormatted: [] };
  let financialResources = { raw: [], formatted: [], approved: [], approvedFormatted: [] };
  let materialResources = { raw: [], formatted: [], approved: [], approvedFormatted: [] };
  if (investigation.resources != null) {
    if (Array.isArray(investigation.resources?.human) && investigation.resources.human.length > 0) {
      humanResources.raw = investigation.resources.human;
      investigation.resources.human.forEach((human) => {
        if (human.approved) {
          humanResources.approved.push(human);
          humanResources.approvedFormatted.push({
            label: human.name,
            value: `${human.name}###${human.expertise}`,
          });
        }
        humanResources.formatted.push({
          label: human.name,
          value: `${human.name}###${human.expertise}`,
        });
      });
    }
    if (Array.isArray(investigation.resources?.access) && investigation.resources.access.length > 0) {
      accessResources.raw = investigation.resources.access;
      investigation.resources.access.forEach((access) => {
        if (access.approved) {
          accessResources.approved.push(access);
          accessResources.approvedFormatted.push({
            label: access.resource,
            value: `${access.resource}###${access.details}`,
          });
        }
        accessResources.formatted.push({
          label: access.resource,
          value: `${access.resource}###${access.details}`,
        });
      });
    }
    if (Array.isArray(investigation.resources?.financial) && investigation.resources.financial.length > 0) {
      financialResources.raw = investigation.resources.financial;
      investigation.resources.financial.forEach((financial) => {
        if (financial.approved) {
          financialResources.approved.push(financial);
          financialResources.approvedFormatted.push({
            label: financial.resource,
            value: `${financial.resource}###${financial.details}`,
          });
        }
        financialResources.formatted.push({
          label: financial.resource,
          value: `${financial.resource}###${financial.details}`,
        });
      });
    }
    if (Array.isArray(investigation.resources?.material) && investigation.resources.material.length > 0) {
      materialResources.raw = investigation.resources.material;
      investigation.resources.material.forEach((material) => {
        if (material.approved) {
          materialResources.approved.push(material);
          materialResources.approvedFormatted.push({
            label: material.resource,
            value: `${material.resource}###${material.details}`,
          });
        }
        materialResources.formatted.push({
          label: material.resource,
          value: `${material.resource}###${material.details}`,
        });
      });
    }
  }
  return {
    humanResourcesInfo: humanResources,
    accessResourcesInfo: accessResources,
    financialResourcesInfo: financialResources,
    materialResourcesInfo: materialResources,
  }
}

// Formateo de involucrados de la investigación
export const formatInvestigationInvolveds = (investigation) => {
  let involveds = { raw: [], formatted: [] };
  let involvedsAccomplice = { raw: [], formatted: [] };
  let involvedsOffender = { raw: [], formatted: [] };
  let involvedsVictim = { raw: [], formatted: [] };
  let involvedsWitness = { raw: [], formatted: [] };
  if (investigation.involved != null) {
    if (typeof investigation.involved === 'object' && 
      Array.isArray(investigation.involved.accomplice) &&
      Array.isArray(investigation.involved.offender) &&
      Array.isArray(investigation.involved.victim) &&
      Array.isArray(investigation.involved.witness)) {
      const involvedsArray = [ 
        ...investigation.involved.accomplice, 
        ...investigation.involved.offender, 
        ...investigation.involved.victim, 
        ...investigation.involved.witness 
      ];
      involveds = {
        raw: involvedsArray,
        formatted: involvedsArray.map((involved) => {
          return {
            label: involved.name,
            value: `${involved.name}-${involved.rol}`,
          }
        }),
      }
      involvedsAccomplice = {
        raw: investigation.involved.accomplice,
        formatted: investigation.involved.accomplice.map((involved) => {
          return {
            label: involved.name,
            value: `${involved.name}-${involved.rol}`,
          }
        }),
      }
      involvedsOffender = {
        raw: investigation.involved.offender,
        formatted: investigation.involved.offender.map((involved) => {
          return {
            label: involved.name,
            value: `${involved.name}-${involved.rol}`,
          }
        }),
      }
      involvedsVictim = {
        raw: investigation.involved.victim,
        formatted: investigation.involved.victim.map((involved) => {
          return {
            label: involved.name,
            value: `${involved.name}-${involved.rol}`,
          }
        }),
      }
      involvedsWitness = {
        raw: investigation.involved.witness,
        formatted: investigation.involved.witness.map((involved) => {
          return {
            label: involved.name,
            value: `${involved.name}-${involved.rol}`,
          }
        }),
      }
    }
  }
  return { 
    involvedsInfo: involveds,
    involvedsAccompliceInfo: involvedsAccomplice,
    involvedsOffenderInfo: involvedsOffender,
    involvedsVictimInfo: involvedsVictim,
    involvedsWitnessInfo: involvedsWitness,
  };
}